import { render, staticRenderFns } from "./ReservationFloatBtns.vue?vue&type=template&id=ed435ea4&"
import script from "./ReservationFloatBtns.vue?vue&type=script&lang=js&"
export * from "./ReservationFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports